import React, { FC } from 'react';

import ForeignLanguageSubNavigation from './ForeignLanguageSubNavigation';
import { LanguageScope, useLanguages } from '../../shop/language/useLanguages';
import { mapLoanFormat } from '../../../models/LoanFormat';
import { useParams } from 'react-router';
import { getLoanFormat } from '../utils/getLoanFormat';
import { useAgeCategorySearchParam } from '../utils/useAgeCategorySearchParam';

type Props = {
    readonly isSticky: boolean;
    readonly shopLanguage?: string;
};

const LanguageLearningNavigation: FC<Props> = ({ isSticky, shopLanguage }) => {
    const { languageId, loanFormat } = useParams<'languageId' | 'loanFormat'>();
    const selectedLanguage = languageId ? decodeURIComponent(languageId) : undefined;
    const { value: ageCategory } = useAgeCategorySearchParam();

    const loanFormatState = getLoanFormat(loanFormat);
    const { languages } = useLanguages({
        scope: LanguageScope.LANGUAGE_LEARNING,
        loanFormat: mapLoanFormat(loanFormatState.requestKey),
        ageCategory,
        shopLanguage
    });

    return (
        <ForeignLanguageSubNavigation
            isSticky={isSticky}
            loanFormat={loanFormatState}
            selectedLanguage={selectedLanguage}
            languages={languages}
            isInLanguageLearning={true}
            hideGenres={true}
            shopLanguage={shopLanguage}
        />
    );
};

export default LanguageLearningNavigation;
